import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import PropTypes from 'prop-types';
import moment from 'moment-business-days';
import { connect } from 'react-redux';
import { Dialog, IconButton } from 'react-toolbox';
import { clearValidation, updatePhaseTask } from 'actionCreators';
import { getPhaseErrors } from '../../../../../../reducers';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import TextArea from 'components/TextArea';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import S from 'modal.scss';

class MaterialsOrderedModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    eta: '',
    note: '',
    errors: {},
    sendError: false,
  }
  static VALIDATIONS = {
    eta: true,
    note: true,
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  handleEtaChange = eta => this.setState({ eta });

  handleNoteChange = e => this.setState({ note: e.target.value });

  data = () => ({ event: { data: {
    note: `ETA: ${this.state.eta}
${this.state.note}`,
  } } });

  handleSubmit = () => {
    if (!this.validate()) return;
    const task = { status: 'complete' };
    const data = this.data();
    this.props.updatePhaseTask(
      this.props.phase.id,
      this.props.task.slug,
      { task, ...data },
    )
      .then(() => this.handleClose())
      .catch(result => this.setState({
        sendError: true, errors: result.payload.errors,
      }));
  }

  render = () => {
    const { eta, note, errors } = this.state;
    return (<Dialog
      active={this.props.active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Materials Ordered</h5>
      <br />
      <DatePicker
        label="Designate an ETA"
        minDate={moment().toDate()}
        value={eta}
        onChange={this.handleEtaChange}
        className={S.datePicker}
        placeholder="Select Date"
        error={errors.eta}
      />
      <TextArea
        label="Notes"
        value={note}
        errors={errors.note}
        onChange={this.handleNoteChange}
      />
      <div className={S.actions}>
        <ColoredButton
          color="green"
          responsive
          label="Complete Task"
          className={S.button}
          onClick={this.handleSubmit}
        />
        <ColoredButton
          color="darkGray"
          responsive
          label="Cancel"
          className={S.button}
          onClick={this.handleClose}
        />
      </div>
    </Dialog>);
  }
}

MaterialsOrderedModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  addFlagToPhase: PropTypes.func.isRequired,
};

MaterialsOrderedModal.defaultProps = { active: false };

export default connect(state => ({ errors: getPhaseErrors(state) }), {
  clearValidation,
  updatePhaseTask,
})(MaterialsOrderedModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/materialsOrderedModal.jsx